import React from "react";
import "./index.css";
import { Button, Card, Row, Typography } from "antd";
import { DocumentTitle } from "../../components";
import I18n from "../../i18n";
import { WhatsAppOutlined, InstagramOutlined, PhoneOutlined } from "@ant-design/icons"

export default function Contact() {
  return (
    <DocumentTitle title={I18n.general.contactUs}>
      <Card
        style={{ margin: 32, boxShadow: "5px 8px 24px 5px rgba(208, 216, 243, 0.4)" }}
        title={
          <Typography.Title level={2} style={{ paddingBottom: 0, marginBottom: 0 }}>
            {I18n.general.support}
          </Typography.Title>
        }
      >
        <Typography.Paragraph>
          {'برای پشتیبانی سفارش های خود می‌توانید از طریق راه های زیر اقدام فرمایید:'}
        </Typography.Paragraph>
        <Typography>
          <Button type="text" onClick={() => { window.location.assign('https://www.instagram.com/mezun_lennaa/') }}>
            <Row>
              <InstagramOutlined className="support-icons" />
              {'دایرکت اینستاگرام (۱۰ تا ۲۲)'}
            </Row>
          </Button>
        </Typography>
        {/* 
        <Typography>
          <Button type="text" onClick={() => { window.location.assign('https://wa.me/+989333111111') }}>
            <Row>
              <WhatsAppOutlined className="support-icons" />
              {'واتسپ (۱۰ تا ۲۲)'}
            </Row>
          </Button>
        </Typography>
        */}
        <Typography>
          <Button type="text" onClick={() => { window.location.assign('tel:09375576230') }}>
            <Row>
              <PhoneOutlined className="support-icons" />
              {'تلفن 09375576230 (۹ تا ۱۳)'}
            </Row>
          </Button>
        </Typography>
        {/*
        <Typography>
          <Button type="text" onClick={() => { window.location.assign('tel:05131234567') }}>
            <Row>
              <PhoneOutlined className="support-icons" />
              {'تلفن 09371234567 (۹ تا 19)'}
            </Row>
          </Button>
        </Typography>
         */}
      </Card>
    </DocumentTitle>
  );
}
